import { upgradeOrganizedTourRemoteImageUrl } from "./organizedTourHeroImageSsot";

const UNSPLASH_BASE = "https://images.unsplash.com";
export const LOGIN_MONTHLY_LICENSE = "Unsplash License";

/**
 * 12 curated tourism heroes — one per calendar month.
 * All images: Unsplash License (https://unsplash.com/license).
 * Attribution is shown in the UI for transparency.
 */
export const LOGIN_MONTHLY_BACKGROUNDS = [
  {
    month: 1,
    id: "jan-alps",
    labelHe: "חורף באלפים",
    labelEn: "Alpine winter",
    photoPath: "photo-1519681393784-d120267933ba",
    photographer: "Joseph Barrientos",
    photographerUrl: "https://unsplash.com/@jbcreate_",
    unsplashUrl: "https://unsplash.com/photos/mountain-covered-with-snow-under-cloudy-sky-4Xv1l5z7_pU",
  },
  {
    month: 2,
    id: "feb-paris",
    labelHe: "פריז בחורף",
    labelEn: "Paris winter",
    photoPath: "photo-1502602898657-3e91760cbb34",
    photographer: "Chris Karidis",
    photographerUrl: "https://unsplash.com/@chriskaridis",
    unsplashUrl: "https://unsplash.com/photos/Eiffel-Tower-Paris-France-nnzkZNYWHaU",
  },
  {
    month: 3,
    id: "mar-bloom",
    labelHe: "אביב בטבע",
    labelEn: "Spring bloom",
    photoPath: "photo-1490750967868-88aa4486c946",
    photographer: "Sergey Shmidt",
    photographerUrl: "https://unsplash.com/@sadswim",
    unsplashUrl: "https://unsplash.com/photos/pink-petaled-flowers-koy6FlCCy5s",
  },
  {
    month: 4,
    id: "apr-santorini",
    labelHe: "סנטוריני",
    labelEn: "Santorini",
    photoPath: "photo-1613395877344-571fabeb2f2b",
    photographer: "Javier Martin",
    photographerUrl: "https://unsplash.com/@javiermartin",
    unsplashUrl: "https://unsplash.com/photos/white-and-blue-concrete-building-near-body-of-water-during-daytime-8XonCuL2fGQ",
  },
  {
    month: 5,
    id: "may-mediterranean",
    labelHe: "חוף ים תיכוני",
    labelEn: "Mediterranean coast",
    photoPath: "photo-1507525428034-b723cf961d3e",
    photographer: "Sean Oulashin",
    photographerUrl: "https://unsplash.com/@seaolas",
    unsplashUrl: "https://unsplash.com/photos/seashore-under-white-and-blue-sky-KMn4VEeEPR8",
  },
  {
    month: 6,
    id: "jun-resort",
    labelHe: "נופש וספא",
    labelEn: "Resort pool",
    photoPath: "photo-1571896349842-33c89424de2d",
    photographer: "Ralph (Ravi) Kayden",
    photographerUrl: "https://unsplash.com/@ravi_kayden",
    unsplashUrl: "https://unsplash.com/photos/brown-wooden-dock-between-lavender-flower-field-near-body-of-water-during-daytime-mR1CIFyOmRI",
  },
  {
    month: 7,
    id: "jul-maldives",
    labelHe: "איים טרופיים",
    labelEn: "Tropical islands",
    photoPath: "photo-1512343879784-a960bf40e7f2",
    photographer: "Asad Photo Maldives",
    photographerUrl: "https://unsplash.com/@asadphoto",
    unsplashUrl: "https://unsplash.com/photos/body-of-water-near-mountains-P76u5XaJp7E",
  },
  {
    month: 8,
    id: "aug-yacht",
    labelHe: "ים כחול עמוק",
    labelEn: "Deep blue sea",
    photoPath: "photo-1544551763-46a013bb70d5",
    photographer: "Silas Baisch",
    photographerUrl: "https://unsplash.com/@silasbaisch",
    unsplashUrl: "https://unsplash.com/photos/white-boat-on-sea-during-daytime-K785Da4A_Y4",
  },
  {
    month: 9,
    id: "sep-barcelona",
    labelHe: "ברצלונה",
    labelEn: "Barcelona",
    photoPath: "photo-1583422409513-0275c4b4afb8",
    photographer: "Toa Heftiba",
    photographerUrl: "https://unsplash.com/@heftiba",
    unsplashUrl: "https://unsplash.com/photos/people-walking-near-buildings-during-daytime-YsPZ_O1vH0E",
  },
  {
    month: 10,
    id: "oct-venice",
    labelHe: "סתיו בוונציה",
    labelEn: "Venice autumn",
    photoPath: "photo-1523906834658-6e24ef2386f9",
    photographer: "Damiano Basile",
    photographerUrl: "https://unsplash.com/@damianobasile",
    unsplashUrl: "https://unsplash.com/photos/canal-between-buildings-oMPFR-UBeFM",
  },
  {
    month: 11,
    id: "nov-desert",
    labelHe: "מדבר זהוב",
    labelEn: "Golden desert",
    photoPath: "photo-1509316785289-025f5b846b35",
    photographer: "Cristofer Maximilian",
    photographerUrl: "https://unsplash.com/@cristofer",
    unsplashUrl: "https://unsplash.com/photos/brown-sand-under-blue-sky-during-daytime-m_7pVk-V5dM",
  },
  {
    month: 12,
    id: "dec-escape",
    labelHe: "בריחה לחורף חם",
    labelEn: "Winter sun escape",
    photoPath: "photo-1520250497591-112f2f40a3f4",
    photographer: "Shiraz Shah",
    photographerUrl: "https://unsplash.com/@shiraz_shah",
    unsplashUrl: "https://unsplash.com/photos/brown-wooden-dock-between-lavender-flower-field-near-body-of-water-during-daytime-8wTPqxlnKM4",
  },
];

export const MONTH_NAMES_HE = [
  "ינואר",
  "פברואר",
  "מרץ",
  "אפריל",
  "מאי",
  "יוני",
  "יולי",
  "אוגוסט",
  "ספטמבר",
  "אוקטובר",
  "נובמבר",
  "דצמבר",
];

function photoUrlForPath(photoPath) {
  const path = String(photoPath || "").trim();
  if (!path) return "";
  return upgradeOrganizedTourRemoteImageUrl(`${UNSPLASH_BASE}/${path}`);
}

/** @returns {Array<typeof LOGIN_MONTHLY_BACKGROUNDS[number] & { url: string, license: string }>} */
export function getLoginMonthlyBackgroundCatalog() {
  return LOGIN_MONTHLY_BACKGROUNDS.map((item) => ({
    ...item,
    url: photoUrlForPath(item.photoPath),
    license: LOGIN_MONTHLY_LICENSE,
  }));
}

/**
 * Calendar month (1–12) → curated hero.
 * @param {number} [month] 1–12; defaults to current local month
 */
export function getMonthlyLoginBackground(month) {
  const catalog = getLoginMonthlyBackgroundCatalog();
  const m =
    Number.isFinite(month) && month >= 1 && month <= 12
      ? Math.floor(month)
      : new Date().getMonth() + 1;
  const item = catalog.find((entry) => entry.month === m) || catalog[0];
  return {
    ...item,
    monthIndex: m,
    monthNameHe: MONTH_NAMES_HE[m - 1],
  };
}
